export default {
    isEmployabilityFormOpen: state => state.employabilityFormIsOpen,
    isOpinionFormOpen: state => state.opinionFormIsOpen,

    getDataTableOptions: state => state.dataTableOptions,
    getActions: state => state.actions,
    getFormActions: state => state.formActions,
    getRowActions: state => state.rowActions,
    getReadOnlyRowActions: state => state.rowActionsReadOnly,
    getHeaderFields: state => state.headerFields,
}
